import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { CashDrawerChangeStaff } from "./CashDrawerChangeStaff";
import type { OrderPaymentStaff } from "./OrderPaymentStaff";
import type { OrderRefundStaff } from "./OrderRefundStaff";
import type { PaymentRefundDTOBase } from "./PaymentRefundDTOBase";
import type { PaymentRefundDestination } from "./PaymentRefundDestination";
import type { PaymentRefundStatus } from "./PaymentRefundStatus";
import type { TrackedModernBase } from "./TrackedModernBase";

export class PaymentRefundStaff implements PaymentRefundDTOBase, TrackedModernBase {
  constructor(public readonly assignId: number, public readonly destinationType: PaymentRefundDestination, public readonly amountRefundedCents: number, public readonly paymentRefundStatus: PaymentRefundStatus, public readonly processorRefundId: string | null, public readonly processorRefundStatus: string | null, public readonly failureMessage: string | null, public readonly cashDrawerChange: CashDrawerChangeStaff | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly orderRefundId: OrderRefundStaff | null, public readonly paymentId: OrderPaymentStaff | null) {
    this.cbiServiceContext = null;
    this.cashDrawerChangeLoaded = this.cashDrawerChange != null;
    this.cashDrawerChangeCached = this.cashDrawerChange;
    this.orderRefundIdLoaded = this.orderRefundId != null;
    this.orderRefundIdCached = this.orderRefundId;
    this.paymentIdLoaded = this.paymentId != null;
    this.paymentIdCached = this.paymentId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private cashDrawerChangeLoaded: boolean;
  private cashDrawerChangeCached: CashDrawerChangeStaff | null;
  private orderRefundIdLoaded: boolean;
  private orderRefundIdCached: OrderRefundStaff | null;
  private paymentIdLoaded: boolean;
  private paymentIdCached: OrderPaymentStaff | null;
  async cashDrawerChangeLazy(): Promise<CashDrawerChangeStaff | null> {
    if (!this.cashDrawerChangeLoaded) {
      this.cashDrawerChangeCached = await this.cbiServiceContext!.orderRefundService().getPaymentRefundStaffCashDrawerChange(this.assignId);
      this.cashDrawerChangeLoaded = true;
    }
    return this.cashDrawerChangeCached;
  }
  async orderRefundIdLazy(): Promise<OrderRefundStaff> {
    if (!this.orderRefundIdLoaded) {
      this.orderRefundIdCached = await this.cbiServiceContext!.orderRefundService().getPaymentRefundStaffOrderRefundId(this.assignId);
      this.orderRefundIdLoaded = true;
    }
    return this.orderRefundIdCached!;
  }
  async paymentIdLazy(): Promise<OrderPaymentStaff> {
    if (!this.paymentIdLoaded) {
      this.paymentIdCached = await this.cbiServiceContext!.orderRefundService().getPaymentRefundStaffPaymentId(this.assignId);
      this.paymentIdLoaded = true;
    }
    return this.paymentIdCached!;
  }
}
